import React, { useEffect, useState, useRef } from "react";
import {
  Tooltip,
  makeStyles,
  Avatar,
  TableCell,
  TableRow,
  TableCellLayout,
  PopoverTrigger,
  Popover,
  PopoverSurface,
} from "@fluentui/react-components";
import {
  ClockIcon,
  FlagIcon,
  MeatBallsMenuIcon,
  PlusIcon,
} from "../../../../../modules/default-svg";
import HoverCard from "../../../../hoverCard/HoverCard";
import {
  utcToLocalDateString,
  getAccountCurrency,
  displayDecimalFormatted,
} from "../../../../../utils/systemSettings";
import CustomInput from "../../../input/customInput/CustomInput";
import CheckboxInput from "../../../checkbox/Checkbox";
import { useDispatch } from "react-redux";
import {
  createUserRequest,
  updateUserRequest,
} from "../../../../../store/actions/user.actions";
import { generalActions } from "../../../../../store/actions";
import CustomSelect from "../../../select/CustomSelect";
import service from "../../../../../store/services/user.service";

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: "#342c82",
    color: "#FFFFFF",
  },
});

const ResourceRow = (props) => {
  const {
    item,
    sortingCriteria,
    data,
    handleModal,
    updateStatus,
    setUpdateStatus,
    updateFlag,
    updateUserStatus,
    menu,
    sortResourceRequest,
    columnConfig,
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [flagged, setFlagged] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState({});
  const [setting] = useState(settings);
  const popoverRef = useRef(null);
  const inputRef = useRef(null);
  const titleInputRef = useRef(null);
  const hourlyRateInputRef = useRef(null);
  const totalHoursInputRef = useRef(null);
  const operationalCapacityInputRef = useRef(null);
  const projectCapacityInputRef = useRef(null);
  const emailInpurRef = useRef(null);
  const roleSelectRef = useRef(null);
  const [roleOptions, setRoleOptions] = useState();

  // new inmplementation
  const [isEditRecord, setIsEditRecord] = useState(null);
  const [formErrors, setFormErrors] = useState({
    name: "",
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (sortingCriteria.column !== null) {
      sortResourceRequest({
        page: 1,
        size: 10,
        orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
      });
    }
  }, [sortingCriteria]);

  useEffect(() => {
    if (updateStatus) {
      updateUserStatus({
        id: item.id,
        payload: [
          {
            op: "replace",
            path: "/isActive",
            value: !item.isActive,
          },
        ],
      });
      setUpdateStatus(false);
    }
  }, [updateStatus]);

  useEffect(() => {
    if (typeof data != "string") {
      data
        .filter((d) => d.isFlagged)
        .map((f) => {
          if (!flagged.includes(f.id)) {
            setFlagged((prevItems) => [...prevItems, f.id]);
          }
        });
      const tempData = [...data];
      tempData.push({
        name: "",
        title: "",
        email: "",
        hourlyRate: "",
        maxHours: "",
        operationalCapacity: "",
        projectCapacity: "",
        isExternal: false,
        isActive: true,
      });
      setSortedData(tempData);
    }
  }, [data]);

  useEffect(() => {
    if (menu.props.closePopover) {
      setPopoverOpen(null);
    }
  }, [menu.props.closePopover]);

  const handlePopoverOpen = (rowId) => {
    setPopoverOpen(rowId);
  };

  const handleEditable = (event) => {
    if (event.key === "Escape") {
      setIsEditRecord(null);
    } else if (event.key === "Enter") {
      if (isEditRecord) {
        handleBlur();
      }
    }
  };

  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      event.target?.innerText !== "Edit" &&
      event.target?.innerText !== "Delete" &&
      event.target?.innerText !== "Activate user" &&
      event.target?.innerText !== "Deactivate user" &&
      event.target?.innerText !== "Remind me" &&
      event?.target?.tagName !== "svg"
    ) {
      if (popoverOpen) {
        handlePopoverOpen(null);
      }
    }
    if (
      isEditRecord &&
      event.target.localName !== "input" &&
      event.target.localName !== "div"
    ) {
      handleBlur();
    } else if (isEditRecord && event.target.placeholder === "Search") {
      handleBlur();
    }
  };

  const handleScroll = (e) => {
    handlePopoverOpen(null);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("wheel", handleScroll);
    document.addEventListener("keydown", handleEditable);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("wheel", handleScroll);
      document.removeEventListener("keydown", handleEditable);
    };
  }, [isEditRecord, popoverOpen]);
  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////

  const addFlag = (id) => {
    setFlagged((prevItems) => [...prevItems, id]);
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: true,
        },
      ],
    });
  };

  const removeFlag = (item) => {
    const id = item.id;
    setFlagged((prevItems) => prevItems.filter((item) => item !== id));
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: false,
        },
      ],
    });
  };

  useEffect(() => {
    const sortedArray = data;
    const tempData = [...sortedArray];
    tempData.push({
      fullName: "",
      title: "",
      email: "",
      roles: [],
      hourlyRate: "",
      maxHours: "",
      operationalCapacity: "",
      projectCapacity: "",
      isExternal: false,
      isActive: true,
    });
    setSortedData(tempData);
  }, [flagged]);

  const sortDataByFlagged = (dataArray, flaggedArray) => {
    const flaggedItems = [];
    const remainingItems = [];

    dataArray.forEach((item) => {
      if (flaggedArray.includes(item.id)) {
        flaggedItems.push(item);
      } else {
        remainingItems.push(item);
      }
    });

    flaggedItems.sort((a, b) => {
      return flaggedArray.indexOf(a.id) - flaggedArray.indexOf(b.id);
    });

    return [...flaggedItems, ...remainingItems];
  };

  const handleInputChange = (value, type) => {
    const data = JSON.parse(JSON.stringify(isEditRecord));
    if (type === "name") {
      setFormErrors({ ...formErrors, name: "" });
      data.name.fullName = value;
      setIsEditRecord(data);
    } else if (type === "title") {
      data.name.title = value;
      setIsEditRecord(data);
    } else if (type === "email") {
      setFormErrors({ ...formErrors, email: "" });
      data.name.email = value;
      setIsEditRecord(data);
    } else if (type === "roles") {
      setFormErrors({ ...formErrors, roles: "" });
      data.name.roles = value ? [{ id: value.value, name: value.label }] : [];
      setIsEditRecord(data);
    } else if (type === "hourlyRate") {
      data.name.hourlyRate = value;
      setIsEditRecord(data);
    } else if (type === "totalHours") {
      data.name.maxHours = value;
      setIsEditRecord(data);
    } else if (type === "operationalCapacity") {
      data.name.operationalCapacity = value;
      setIsEditRecord(data);
    } else if (type === "projectCapacity") {
      data.name.projectCapacity = value;
      setIsEditRecord(data);
    } else if (type === "userStatus") {
      data.name.isExternal = value;
      setIsEditRecord(data);
    } else if (type === "user") {
      data.name.isActive = value;
      setIsEditRecord(data);
    }
  };

  const handleIsEdiRecord = (index, type) => {
    if (index === data.length) {
      sortedData[index] = {
        ...isEditRecord?.name,
      };
    }
    if (isEditRecord && isEditRecord.index === index) {
      focusField(type);
      return;
    }

    setIsEditRecord({ index: index, name: sortedData[index] });
    setTimeout(() => {
      focusField(type);
    }, 0);
  };

  const focusField = (type) => {
    if (type === "name") {
      inputRef.current.focus();
    } else if (type === "title") {
      titleInputRef.current.focus();
    } else if (type === "email") {
      emailInpurRef.current.focus();
    } else if (type === "roles") {
      roleSelectRef.current.focus();
    } else if (type === "hourlyRate") {
      hourlyRateInputRef?.current?.focus();
    } else if (type === "totalHours") {
      totalHoursInputRef?.current?.focus();
    } else if (type === "operationalCapacity") {
      operationalCapacityInputRef?.current?.focus();
    } else if (type === "projectCapacity") {
      projectCapacityInputRef?.current?.focus();
    }
  };

  const handleBlur = () => {
    let data = { ...isEditRecord.name };
    if (data.fullName) {
      let len = data.fullName.trim().split(" ");
      if (len.length === 1) {
        data.firstName = len[0];
        data.lastName = "";
      } else {
        data.firstName = len[0];
        data.lastName = len[len.length - 1];
      }
    }
    if (Array.isArray(data.roles)) {
      data.roles = data.roles.map((item) => item.id);
    } else {
      data.roles = [];
    }

    delete data.dateCreated;
    delete data.groups;
    delete data.profilePictureUrl;
    delete data.responsibilities;
    delete data.isFlagged;

    if (
      data.firstName &&
      data.lastName &&
      data.fullName &&
      data.email &&
      data.roles.length > 0
    ) {
      if (data.id) {
        dispatch(
          updateUserRequest({
            id: sortedData[isEditRecord.index].id,
            payload: data,
          })
        );
      } else {
        dispatch(createUserRequest({ payload: data }));
      }
      setIsEditRecord(null);
    } else {
      const errors = {};
      if (!data.fullName) errors["name"] = `The Name field is required.`;
      if (!data.lastName) errors["name"] = `The LastName field is required`;
      if (!data.email) errors["email"] = `The Email field is required.`;
      if (data.roles.length === 0)
        errors["roles"] = `The Roles field is required.`;
      setFormErrors(errors);
      if (!data.fullName) {
        dispatch(
          generalActions.showToast({
            title: "Name is a required field",
            type: "error",
          })
        );
      } else if (!data.email) {
        dispatch(
          generalActions.showToast({
            title: "Email is a required field",
            type: "error",
          })
        );
      } else if (data.roles.length === 0) {
        dispatch(
          generalActions.showToast({
            title: "Role is a required field",
            type: "error",
          })
        );
      } else if (!data.lastName) {
        dispatch(
          generalActions.showToast({
            title: "Last Name is a required field",
            type: "error",
          })
        );
      }
    }
  };

  const searchRoleHandler = (value) => {
    if (value === "") {
      setRoleOptions([]);
      return;
    }
    service
      .searchRoleDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setRoleOptions(transformedArray);
      })
      .catch((err) => {
        setRoleOptions([]);
      });
  };

  const handleFocus = (e, type) => {
    if (type === "select") {
      e.target.click();
    }
  };

  const sortedColumnConfig = [...columnConfig].sort(
    (a, b) => a.order - b.order
  );

  const renderTableCell = (item, index, column) => {
    const isEditing = isEditRecord && isEditRecord.index === index;

    switch (column.label) {
      case "Name": // Assuming this is the label for the fullName column
        return (
          <TableCell role="gridcell">
            <div className="d-flex justify-content-between">
              <TableCellLayout
                media={
                  <>
                    {item?.id && (
                      <Tooltip
                        positioning="before"
                        content={{
                          children: flagged.includes(item.id)
                            ? "Unflag"
                            : "Flag",
                          className: styles.tooltip,
                        }}
                        relationship="label"
                        withArrow
                      >
                        <span
                          className={`flag ${
                            flagged.includes(item.id) ? "flagActive" : ""
                          }`}
                          onClick={() =>
                            flagged.includes(item.id)
                              ? removeFlag(item)
                              : addFlag(item.id)
                          }
                        >
                          <FlagIcon />
                        </span>
                      </Tooltip>
                    )}
                    {isEditing ? (
                      <CustomInput
                        inputwd="me-3"
                        icon={false}
                        placeholder="Enter fullname"
                        value={isEditRecord.name.fullName}
                        type="text"
                        handleChange={(value) =>
                          handleInputChange(value, "name")
                        }
                        ref={inputRef}
                        errorMessage={formErrors.name}
                        displayErrorMessage={false}
                      />
                    ) : item?.id ? (
                      <div
                        className="d-flex justify-content-between gap-2"
                        onClick={() => handleIsEdiRecord(index, "name")}
                      >
                        <HoverCard
                          HoverCardTrigger={
                            <Avatar
                              color="colorful"
                              name={item.fullName}
                              image={{ src: item.profilePictureUrl }}
                            />
                          }
                          AvatarId={item.id}
                          AvatarName={item.fullName}
                          AvatarDesignation={item.title}
                          AvatarImage={item.profilePictureUrl}
                          AvatarEmail={item.email}
                          AvatarPhone={item.phoneNumber}
                          AvatarIsExternal={item.isExternal}
                        />
                        <span className="text-sm-400 mt-1">
                          {item.fullName}
                        </span>
                      </div>
                    ) : (
                      <div
                        className="d-flex _add_btn"
                        onClick={() => handleIsEdiRecord(index, "name")}
                      >
                        <PlusIcon />
                        <span style={{ fontSize: "14px" }}>Add</span>
                      </div>
                    )}
                  </>
                }
              ></TableCellLayout>
              {item?.id && (
                <div className="flag">
                  <Popover
                    open={popoverOpen === item.id}
                    onOpenChange={(isOpen) =>
                      isOpen && handlePopoverOpen(item.id)
                    }
                    positioning="below-start"
                  >
                    <PopoverTrigger disableButtonEnhancement>
                      <TableCellLayout
                        media={<MeatBallsMenuIcon />}
                        onClick={() => handleModal(item)}
                      />
                    </PopoverTrigger>
                    <PopoverSurface
                      tabIndex={-1}
                      className="listingPopoverWrapper"
                    >
                      {menu}
                    </PopoverSurface>
                  </Popover>
                </div>
              )}
            </div>
          </TableCell>
        );
      case "Email":
        return (
          <TableCell
            onClick={() => handleIsEdiRecord(index, "email")}
            className="text-truncate"
          >
            {isEditing ? (
              <CustomInput
                icon={false}
                placeholder="Enter email"
                value={isEditRecord.name.email}
                type="text"
                handleChange={(value) => handleInputChange(value, "email")}
                ref={emailInpurRef}
              />
            ) : (
              <span>{item.email}</span>
            )}
          </TableCell>
        );
      case "Role":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "roles")}>
            {isEditing ? (
              <CustomSelect
                SelectText="Role"
                multiselect={false}
                searchText={searchRoleHandler}
                options={roleOptions}
                defaultVal={
                  isEditRecord.name.roles?.length > 0
                    ? {
                        label: isEditRecord.name.roles[0].name,
                        value: isEditRecord.name.roles[0].id,
                      }
                    : null
                }
                onChange={(value) => handleInputChange(value, "roles")}
                errorMessage={formErrors.role}
                onFocus={(e) => handleFocus(e, "select")}
                ref={roleSelectRef}
              />
            ) : (
              <span>{item.roles?.length > 0 ? item.roles[0].name : ""}</span>
            )}
          </TableCell>
        );
      case "Title":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "title")}>
            {isEditing ? (
              <CustomInput
                icon={false}
                placeholder="Enter title"
                value={isEditRecord.name.title}
                type="text"
                handleChange={(value) => handleInputChange(value, "title")}
                ref={titleInputRef}
              />
            ) : (
              <span>{item.title}</span>
            )}
          </TableCell>
        );
      case "Hourly Rate":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "hourlyRate")}>
            {isEditing ? (
              <CustomInput
                inputwd="me-3"
                inputClass="Input_Icon"
                placeholder="0"
                value={isEditRecord.name.hourlyRate}
                type="number"
                currency={true}
                inline={true}
                handleChange={(value) => handleInputChange(value, "hourlyRate")}
                ref={hourlyRateInputRef}
              />
            ) : item.hourlyRate ? (
              `${getAccountCurrency(setting)}${displayDecimalFormatted(
                setting,
                item.hourlyRate
              )}`
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Max Hours":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "totalHours")}>
            {isEditing ? (
              <CustomInput
                icon={<ClockIcon />}
                inputClass="Input_Icon"
                placeholder="Enter max hours"
                value={isEditRecord.name.maxHours}
                type="number"
                handleChange={(value) => handleInputChange(value, "totalHours")}
                ref={totalHoursInputRef}
              />
            ) : item.maxHours ? (
              `${displayDecimalFormatted(setting, item.maxHours)}h`
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Operational Capacity":
        return (
          <TableCell
            onClick={() => handleIsEdiRecord(index, "operationalCapacity")}
          >
            {isEditing ? (
              <CustomInput
                inputwd="me-3"
                icon={false}
                placeholder="Operational capacity"
                value={isEditRecord.name.operationalCapacity}
                type="number"
                handleChange={(value) =>
                  handleInputChange(value, "operationalCapacity")
                }
                ref={operationalCapacityInputRef}
              />
            ) : item.operationalCapacity ? (
              `${displayDecimalFormatted(setting, item.operationalCapacity)}%`
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Project Capacity":
        return (
          <TableCell
            onClick={() => handleIsEdiRecord(index, "projectCapacity")}
          >
            {isEditing ? (
              <CustomInput
                icon={false}
                placeholder="Project capacity"
                type="number"
                value={isEditRecord.name.projectCapacity}
                handleChange={(value) =>
                  handleInputChange(value, "projectCapacity")
                }
                ref={projectCapacityInputRef}
              />
            ) : item.projectCapacity ? (
              `${displayDecimalFormatted(setting, item.projectCapacity)}%`
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Users":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "userStatus")}>
            {isEditing ? (
              <div className={`d-flex align-items-center w-100`}>
                <CheckboxInput
                  label="External"
                  checked={isEditRecord.name.isExternal}
                  setChecked={(value) => handleInputChange(value, "userStatus")}
                />
              </div>
            ) : item?.id ? (
              item.isExternal ? (
                <span className="pill grey">External</span>
              ) : (
                <span className="pill purple">Internal</span>
              )
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Creation Date":
        return (
          <TableCell>
            {item.dateCreated
              ? utcToLocalDateString(setting, item.dateCreated)
              : ""}
          </TableCell>
        );
      case "Status":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "user")}>
            {isEditing ? (
              <div className={`d-flex align-items-center w-100`}>
                <CheckboxInput
                  label="Active"
                  checked={isEditRecord.name.isActive}
                  setChecked={(value) => handleInputChange(value, "user")}
                />
              </div>
            ) : item?.id ? (
              item.isActive ? (
                <span className="pill success">Active</span>
              ) : (
                <span className="pill warning">Inactive</span>
              )
            ) : (
              ""
            )}
          </TableCell>
        );
      default:
        return null;
    }
  };

  const styles = useStyles();
  return sortedData.map((item, index) => (
    <TableRow key={item.id || index} ref={popoverRef}>
      {sortedColumnConfig
        .filter((column) => column.isVisible)
        .map((col) => renderTableCell(item, index, col))}
    </TableRow>
  ));
};

export default ResourceRow;
